import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Container, Sidebar, SidebarClose, Content, Logo, MenuItem, Header, UserInfo, MobileToggle } from './styles';
import ChatWidget from '../ChatWidget';
import { FaHome, FaUser, FaEnvelope, FaHandshake, FaCalendar, FaFileInvoice, FaHeart, FaSignOutAlt, FaGlobeAmericas, FaPercent, FaHeadset, FaTag } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { decodeJWT } from '../../../src/utils/jwt';
import { fetchAuth } from '../../services/apiClient';
import logoNegativo from '/jovilogo.png';
import ScrollToTop from '../ScrollToTop';

function getGreeting() {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'Bom dia';
  if (hour >= 12 && hour < 18) return 'Boa tarde';
  return 'Boa noite';
}

const DashboardLayout = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const enableChat = !import.meta.env.DEV || String(import.meta.env.VITE_ENABLE_CHAT || '').toLowerCase() === 'true';

  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [atdPendentes, setAtdPendentes] = useState(0);

  // Recupera dados do usuário a partir do JWT
  let userName = 'Usuário';
  let userCode = '0';
  let userRole = null; 
  const token = localStorage.getItem('auth_token');
  try {
    if (token) {
      const payload = decodeJWT(token);
      if (payload && payload.nome) {
        userName = payload.nome;
      }
      if (payload && payload.codigo) {
        userCode = payload.codigo;
      }
      if (payload && payload.role) {
        userRole = String(payload.role).toUpperCase(); // role será 'ADMIN', 'PARTICULAR', etc
      }
    }
  } catch (e) {
    userName = 'Usuário';
    userRole = null; 
    userCode = '0';
  }

  // Contador de conversas aguardando no menu Atendimento (somente ADMIN)
  useEffect(() => {
    if (userRole !== 'ADMIN') return undefined;
    let alive = true;
    const load = async () => {
      try {
        const { res, data } = await fetchAuth('/api/chat/ai/estatisticas');
        if (alive && res.ok && data) {
          const n = data?.contadores?.aguardando ?? data?.aguardando ?? 0;
          setAtdPendentes(Number(n) || 0);
        }
      } catch { /* noop */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [userRole]);

  // ADMIN, PARTICULAR, PROFISSIONAL, EMPREENDIMENTO
  const menuItems = [
    { type: "HASHMENU", id: "dashboard", label: "Dashboard", icon: <FaHome />, link: "/dashboard", roles: ["ADMIN","PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "DIVIDER" },
        { type: "HASHMENU", id: "all-listings", label: "Todos Anúncios", icon: <FaHome />, link: "/dashboard/all-listings", roles: ["ADMIN"] },

    { type: "HASHMENU", id: "crm-leads", label: "CRM", icon: <FaHandshake />, link: "/dashboard/crm-leads", roles: ["ADMIN","PROFISSIONAL","EMPREENDIMENTO","PARTICULAR"] },
    { type: "HASHMENU", id: "favorites", label: "Favoritos", icon: <FaHeart />, link: "/dashboard/favorites", roles: ["PROFISSIONAL","EMPREENDIMENTO","PARTICULAR"] },
    { type: "HASHMENU", id: "invoices", label: "Faturas", icon: <FaFileInvoice />, link: "/dashboard/invoices", roles: ["PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "agents", label: "Meus Agentes", icon: <FaUser />, link: "/dashboard/agents", roles: ["PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "listings", label: "Meus Anúncios", icon: <FaHome />, link: "/dashboard/listings", roles: ["PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "packages", label: "Meus Pacotes", icon: <FaHome />, link: "/dashboard/packages", roles: ["PROFISSIONAL","EMPREENDIMENTO", "PARTICULAR"] },
    { type: "HASHMENU", id: "payments", label: "Meus Pagamentos", icon: <FaFileInvoice />, link: "/dashboard/payments", roles: ["PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "messages", label: "Mensagens", icon: <FaEnvelope />, link: "/dashboard/messages", roles: ["PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "agency", label: "Minha Agência", icon: <FaHome />, link: "/dashboard/agency", roles: ["PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "reservations", label: "Reservas", icon: <FaCalendar />, link: "/dashboard/reservations", roles: ["PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "contact-mediation", label: "Ticket", icon: <FaHandshake />, link: "/dashboard/contact-mediation", roles: ["ADMIN","PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "HASHMENU", id: "atendimento", label: "Atendimento", icon: <FaHeadset />, link: "/dashboard/atendimento", roles: ["ADMIN"] },
        { type: "HASHMENU", id: "contato", label: "Contato", icon: <FaFileInvoice />, link: "/dashboard/contato", roles: ["ADMIN"] },
            { type: "HASHMENU", id: "newsletter", label: "Newsletter", icon: <FaFileInvoice />, link: "/dashboard/newsletter", roles: ["ADMIN"] },


    { type: "DIVIDER" },
    { type: "HASHMENU", id: "categorias", label: "Categoria", icon: <FaFileInvoice />, link: "/dashboard/categorias", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "dominios", label: "Domínios", icon: <FaGlobeAmericas />, link: "/dashboard/dominios", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "faq", label: "Faq", icon: <FaFileInvoice />, link: "/dashboard/faq", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "faqtipos", label: "Faq Tipos", icon: <FaFileInvoice />, link: "/dashboard/faqtipos", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "idiomas", label: "Idiomas", icon: <FaHandshake />, link: "/dashboard/idiomas", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "pais", label: "País", icon: <FaFileInvoice />, link: "/dashboard/pais", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "regras-fiscais", label: "Regras fiscais", icon: <FaPercent />, link: "/dashboard/regras-fiscais", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "promocoes", label: "Promoções", icon: <FaTag />, link: "/dashboard/promocoes", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "planos", label: "Planos", icon: <FaFileInvoice />, link: "/dashboard/planos", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "tiposImovel", label: "Tipo", icon: <FaFileInvoice />, link: "/dashboard/tiposImovel", roles: ["ADMIN"] },
    { type: "HASHMENU", id: "tipos-planos", label: "Tipos de Planos", icon: <FaFileInvoice />, link: "/dashboard/tipos-planos", roles: ["ADMIN"] },
    { type: "DIVIDER" },
    { type: "HASHMENU", id: "profile", label: "Perfil", icon: <FaUser />, link: "/dashboard/profile", roles: ["ADMIN","PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
    { type: "DIVIDER" },
    { type: "HASHMENU", id: "logout", label: "Sair", icon: <FaSignOutAlt />, link: "#", roles: ["ADMIN","PARTICULAR","PROFISSIONAL","EMPREENDIMENTO"] },
  ];

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    // Limpe outros dados de sessão se necessário
    navigate('/');
  };

  return (
    <Container>
      <Sidebar $open={isSidebarOpen}>
        <SidebarClose onClick={() => setIsSidebarOpen(false)}>✕</SidebarClose>
        <Logo>
          <Link to="/">
            <img src={logoNegativo} alt="Joviplanet" title="Joviplanet" className="footer-logo" />
          </Link>
        </Logo>

        <nav> 
          {menuItems.filter(item => !item.roles || item.roles.includes(userRole) || item.type === "DIVIDER").map((item, idx) => {
            if (item.type === "DIVIDER") return <hr key={idx} />;
            if (item.type === "HASHMENU") {
              if (item.id === "logout") {
                return (
                  <MenuItem
                    onClick={() => {
                      if (window.innerWidth <= 768) setIsSidebarOpen(false);
                      handleLogout();
                    }}
                    key={item.id}
                  >
                    <Link to="#">{item.icon} {item.label}</Link>
                  </MenuItem>
                );
              }
              return (
                <MenuItem $active={isActive(item.link)} key={item.id}>
                  <Link
                    to={item.link}
                    onClick={() => {
                      if (window.innerWidth <= 768) setIsSidebarOpen(false);
                    }}
                  >
                    {item.icon} {item.label}
                    {item.id === 'atendimento' && atdPendentes > 0 && (
                      <span style={{ marginLeft: 'auto', background: '#dc2626', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 10, padding: '1px 8px' }}>
                        {atdPendentes > 99 ? '99+' : atdPendentes}
                      </span>
                    )}
                  </Link>
                </MenuItem>
              );
            }
            return null;
          })} 
        </nav>
      </Sidebar>

      <Content>
        <Header> 
          <MobileToggle onClick={() => setIsSidebarOpen(prev => !prev)}>
            {isSidebarOpen ? '✕' : '☰'}
          </MobileToggle>
          <UserInfo>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: '#34574A',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: 20,
                marginRight: 8
              }}
              title={userName}
              aria-label={userName}
            >
              {userName.charAt(0).toUpperCase()}
            </div> 
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
              <span style={{ fontWeight: 600 }}>{getGreeting()}, {userName}</span>
              <span style={{ fontSize: 12, color: '#556' }}>
                {userRole ? `Perfil: ${userRole}` : 'Perfil: -'}{userCode ? ` · ID: ${userCode}` : ''}
              </span>
            </div>

          </UserInfo> 
        </Header>

        <main>
          <ScrollToTop />
          <Outlet />
        </main>
      </Content>
      {/* Floating Chat Widget */}
      {enableChat ? <ChatWidget /> : null}
    </Container>
  );
};

export default DashboardLayout;
